import type { PropsWithChildren, ReactNode } from 'react';

type CheckBoxGroupProps = PropsWithChildren<{
  title: string;
}>;

/**
 * Parent component for rendering the checkbox groups in the forms.
 *
 * @param root0 the input props
 * @param root0.children the children to pass down
 * @param root0.title the text heading for this checkbox group
 * @returns component
 */
export default function CheckboxGroup({ children, title }: CheckBoxGroupProps): ReactNode {
  return (
    <div className="mb-4">
      <div className="border-stroke-low mb-1 border-b py-1 font-medium">{title}</div>
      <div className="space-y-2">{children}</div>
    </div>
  );
}
